import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../components/AuthContext";
import defaultProfilePic from "../images/defaultProfilePic.jpg";
import "../styles/ProfilePage.css";
import { useNavigate } from "react-router-dom";
import { CiLogout } from "react-icons/ci"; // Nuevo icono

function ProfilePage() {
    //retrieve authentication functions and user data from AuthContext
    const { user, updatePassword, logout, canChangePassword } = useContext(AuthContext);

    //state variables for password updates
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    //redirect to login if user is not logged in
    useEffect(() => {
        if (!user) {
            navigate("/login");
        }
    }, [user, navigate]);

    console.log(user);

    // Handles password update
    const handlePasswordChange = async (e) => {
        e.preventDefault();
        const result = await updatePassword(currentPassword, newPassword);
        setMessage(result.message);
    };

    // Simple password strength: 0-12 chars scale
    const maxLen = 12;
    const strength = Math.min(newPassword.length, maxLen);

    return (
        <main className="profile-container">
            {/* Left: Update forms */}
            <section className="profile-left">
                {/* Email is read-only. Users cannot change their email address. */}
                {canChangePassword ? (
                    <article>
                        <h2>Change Password</h2>
                        <details open>
                            <summary>Update your password</summary>
                            <form onSubmit={handlePasswordChange} aria-label="Change password">
                                <label htmlFor="currentPassword" className="visually-hidden">Current Password</label>
                                <input id="currentPassword" type="password" placeholder="Current Password" value={currentPassword}
                                       onChange={(e) => setCurrentPassword(e.target.value)} required />
                                <label htmlFor="newPassword" className="visually-hidden">New Password</label>
                                <input id="newPassword" type="password" placeholder="New Password" value={newPassword}
                                       onChange={(e) => setNewPassword(e.target.value)} required />
                                <p>
                                    <strong>Strength:</strong>
                                    <progress max={maxLen} value={strength} aria-label="Password strength" />
                                </p>
                                <button type="submit">Update Password</button>
                            </form>
                        </details>
                    </article>
                ) : (
                    <p className="message" role="status">Password changes aren’t available for Google sign-ins.</p>
                )}

                {message && <p className="message" role="alert">{message}</p>}
            </section>

            {/* Right: User info */}
            <section className="profile-right" aria-labelledby="user-info-heading">
                <figure>
                    <img src={defaultProfilePic} alt="Profile" className="profile-picture" />
                </figure>
                <h2 id="user-info-heading">User Information</h2>
                <address>
                    <p><strong>Email:</strong> {user?.email || "N/A"}</p>
                </address>
                <p><strong>Name:</strong> {user?.name || "N/A"}</p>

                <button onClick={logout} className="logout-button profile">
                    <CiLogout /> Logout
                </button>
            </section>
        </main>
    );
}

export default ProfilePage;
